import "locomotive-scroll/dist/locomotive-scroll.css";
import { Routes, Route, Navigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import About from "./About";
import Home from "./Home";
import Contact from "./Contact";
import Footer from "./Footer";
import Services from "./Services";
import "../styles/splitting-effects.scss";

const IndexCustom = () => {

  return (
    <div className="min-h-screen text-black dark:bg-backgroundDark dark:text-white transition-colors duration-300">
    <Navbar />

    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/home" element={<Navigate to="/" replace />} />

      {/* fallback untuk halaman tidak ditemukan */}
      <Route path="*" element={<Navigate to="/home" replace />} />
    </Routes>
  
    <About />
    <Services />
    <Contact /> 
    <Footer />
  </div>
  );
};

export default IndexCustom;
